"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateParentExists = validateParentExists;
exports.getDanglingChildIds = getDanglingChildIds;
exports.validateStepBlockers = validateStepBlockers;
/**
 * Checks whether a document's parent_id exists in the link index.
 */
function validateParentExists(doc, index) {
    if (!doc.parent_id)
        return true;
    const parent = index.documents.get(doc.parent_id);
    if (!parent)
        return false;
    return parent.exists || parent.archived;
}
/**
 * Returns dangling child references via the backlink index.
 * child_ids is removed from frontmatter; children are derived from parent_id references.
 * This function is now a no-op — kept for API compatibility.
 */
function getDanglingChildIds(_doc, _index) {
    return [];
}
/**
 * Validates the step blockers within a plan.
 */
function validateStepBlockers(plan, index) {
    const issues = [];
    if (!plan.steps)
        return issues;
    for (const step of plan.steps) {
        if (!step.blockedBy || step.blockedBy.length === 0)
            continue;
        for (const blocker of step.blockedBy) {
            // Canonical: stable step id referencing another step in this plan.
            if (plan.steps.some(s => s.id === blocker))
                continue;
            // Legacy: bare step number "3"
            if (/^\d+$/.test(blocker)) {
                const stepNum = parseInt(blocker, 10);
                if (stepNum < 1 || stepNum > plan.steps.length) {
                    issues.push({
                        documentId: plan.id,
                        severity: 'error',
                        message: `Step ${step.order}: invalid blocker "${blocker}" (no step ${stepNum})`,
                    });
                }
                continue;
            }
            // Canonical: comma-separated step numbers "3,4"
            if (/^\d+(,\s*\d+)*$/.test(blocker)) {
                const stepNums = blocker.split(',').map(s => parseInt(s.trim(), 10));
                for (const stepNum of stepNums) {
                    if (stepNum < 1 || stepNum > plan.steps.length) {
                        issues.push({
                            documentId: plan.id,
                            severity: 'error',
                            message: `Step ${step.order}: invalid blocker "${blocker}" (no step ${stepNum})`,
                        });
                    }
                }
                continue;
            }
            // Cross-plan dependency: "{plan-id}" or "{plan-id} N" or "{plan-id} N,M"
            if (blocker.includes('-plan-')) {
                const planId = blocker.split(' ')[0];
                if (!index.documents.has(planId)) {
                    issues.push({
                        documentId: plan.id,
                        severity: 'warning',
                        message: `Step ${step.order}: blocked by missing plan "${planId}"`,
                    });
                }
                continue;
            }
            // Unknown blocker format
            issues.push({
                documentId: plan.id,
                severity: 'warning',
                message: `Step ${step.order}: unknown blocker format "${blocker}"`,
            });
        }
    }
    return issues;
}
